import { IconButton, Loader } from 'ui';
import { Download } from 'ui/icons';

import { useDownloadContract } from '~/contract/hooks/useDownloadContract/useDownloadContract';

export const ContractDownloadIconButton = ({ contractNumber }: { contractNumber: string }) => {
  const { download, isDownloading } = useDownloadContract({ contractNumber });

  return (
    <IconButton
      onClick={async (event) => {
        event.preventDefault();
        download();
      }}
      disabled={isDownloading}
      sx={{ color: 'info.main' }}
    >
      {isDownloading ? <Loader size={30} /> : <Download />}
    </IconButton>
  );
};

export default ContractDownloadIconButton;
